module.exports = __webpack_public_path__ + "static/media/icon_warning.5dde7ebb.svg";